export enum TemplateFormFieldValidationType {
  REQUIRED = 'REQUIRED',
  EMAIL = 'EMAIL',
  MATCHES = 'MATCHES',
  POSITIVE = 'POSITIVE',
  MAX = 'MAX',
  MIN = 'MIN'
}
